import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { tr } from 'date-fns/locale';
import { QueryContextSettingID } from 'src/app/services/query-context/models/IQueryContext';
import {
    QueryContextChange,
    QueryContextService,
} from 'src/app/services/query-context/query-context.service';

@Component({
    selector: 'app-upflit-reference-segment-selector',
    templateUrl: './upflit-reference-segment-selector.component.html',
    styleUrls: ['./upflit-reference-segment-selector.component.scss'],
})
export class UpflitReferenceSegmentSelectorComponent implements OnInit {
    /** Setting id for uplift reference segment */
    @Input()
    upliftReferenceSegmentSettingId!: QueryContextSettingID;

    @Input()
    // availableSegments setter
    set availableSegments(segments: string[]) {
        this._availableSegments = segments;
        // if selected segment is not in available segments, set it to null
        // if (
        //     this.selectedUpliftReferenceSegmentViewModel &&
        //     !this._availableSegments.includes(
        //         this.selectedUpliftReferenceSegmentViewModel
        //     )
        // ) {
        //     this.selectedUpliftReferenceSegmentViewModel = null;
        //     this.queryContextService.changePendingQueryContext({
        //         setting: {
        //             id: this.upliftReferenceSegmentSettingId!,
        //             value: this.selectedUpliftReferenceSegmentViewModel,
        //         },
        //     });
        // }
    }
    get availableSegments() {
        return this._availableSegments;
    }
    _availableSegments: string[] = [];

    get referenceSegmentSelectStatus() {
        // if selected segment is not in available segments, return 'error' else null
        return this.selectedUpliftReferenceSegmentViewModel &&
            !this._availableSegments.includes(
                this.selectedUpliftReferenceSegmentViewModel
            )
            ? 'error'
            : undefined;
    }

    @Input()
    disableSegmentSelection!: boolean;

    selectedUpliftReferenceSegmentViewModel: any = null;

    onSelectedUpliftSegmentModelChange(newSelectedUpliftReferenceSegment: any) {
        this.queryContextService.changePendingQueryContext({
            setting: {
                id: this.upliftReferenceSegmentSettingId!,
                value: this.selectedUpliftReferenceSegmentViewModel,
            },
        });
    }

    constructor(
        private queryContextService: QueryContextService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.queryContextService.appliedQueryContextEmitter.subscribe(
            this.queryContextSubscriber
        );
    }

    queryContextSubscriber = (contextChange: QueryContextChange) => {
        if (contextChange.reason === 'InitialContext') {
            // get upfliftReferenceSegmentSettingId from contextChange
            const setting =
                contextChange.context.settings[
                    this.upliftReferenceSegmentSettingId!
                ] ?? null;
            if (setting != this.selectedUpliftReferenceSegmentViewModel) {
                this.selectedUpliftReferenceSegmentViewModel = setting;
                this.cd.detectChanges();
            }
        }
    };
}
